import React from 'react';
import { Typography } from '@mui/material';
import { AQUA } from '@wave-engagement/wave-react';

const AnonymityRefresher = ({ style = {} }) => {
  return (
    <div style={{ backgroundColor: AQUA, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '30px', ...style }}>
      <Typography variant='body1' style={{ textAlign: 'center', marginBottom: '1.5em' }}>Your responses are confidential and optional.</Typography>
      <Typography variant='body1' style={{ textAlign: 'center', marginBottom: '1.5em' }}>The information you choose to share will be grouped with others to identify trends across your organizational culture. Individual or raw data will not be provided to your organization or anyone else outside of the Wave Engagement team.</Typography>
      <Typography variant='body1' style={{ textAlign: 'center' }}>Earning your trust is vital to us. Contact Emily@WaveEngagement.com if you have any questions or ideas about privacy.</Typography>
    </div>
  );
}
export default AnonymityRefresher;